import React, { useMemo, useState, useEffect } from 'react';

const DEFAULT_TRANSFORM_SCALE = 0.8;

const DESKTOP_DEVICE_WIDTH = 1200;
const DESKTOP_DEVICE_HEIGHT = 800;

const MOBILE_DEVICE_WIDTH = 428;
const MOBILE_DEVICE_HEIGHT = 868;

export const EditorContentFormDevicePreview = ({
  preview,
  isMobile,
  containerDimensions,
}: {
  preview: any;
  isMobile: boolean;
  containerDimensions: any;
}) => {
  const [scale, setScale] = useState(DEFAULT_TRANSFORM_SCALE);
  const width = isMobile ? MOBILE_DEVICE_WIDTH : DESKTOP_DEVICE_WIDTH;
  const height = isMobile ? MOBILE_DEVICE_HEIGHT : DESKTOP_DEVICE_HEIGHT;

  useEffect(() => {
    if (containerDimensions) {
      const containerWidth = containerDimensions.width;
      const containerHeight = containerDimensions.height;

      if (width * scale > containerWidth) {
        const newScale = (containerWidth / (width * scale)) * DEFAULT_TRANSFORM_SCALE;
        setScale(newScale);
      }

      if (height * scale > containerHeight) {
        const newScale = (containerHeight / (height * scale)) * DEFAULT_TRANSFORM_SCALE;
        setScale(newScale);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [containerDimensions]);

  const styles = useMemo(() => {
    return {
      deviceWrapper: {
        transform: `scale(${scale})`,
        transformOrigin: 'left top',
        zIndex: 1,
        height: height * scale,
        width: width * scale,
      },
      deviceFrame: {
        backgroundColor: '#222',
        borderRadius: '24px',
        padding: '16px',
        height: height,
        width: width,
      },
    };
  }, [width, height, scale]);

  return (
    <div className='mx-auto' style={styles.deviceWrapper}>
      <div className='flex relative' style={styles.deviceFrame}>
        {preview}
      </div>
    </div>
  );
};

export default EditorContentFormDevicePreview;
